import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Features } from '../../types/types';

@Injectable({
  providedIn: 'root',
})
export class FeatureApiService {
  baseUrl = '/aptitude/api';

  constructor(private http: HttpClient) {
    //
  }

  // TODO: add interceptor
  getFeatures(): Observable<Features> {
    return this.http.get<Features>(`${this.baseUrl}/features/v2`);
  }
}
